import { CallState } from '@modules/SoftPhoneModule/types';
import { InboxContext } from '../types';
import { setOutboundCallToOffered } from '../callHandlers/outboundCalls';
import { setInternalCallToOffered } from '../callHandlers/internalCalls';
import ServiceModule from '@modules/ServiceModule';

async function handleCallPlaced(context: InboxContext, event: CallState) {
  const from = event.remoteIdentity;
  const direction = event.originating ? 'outbound' : 'inbound';

  // if this call has come through a queue, then there would be a session
  // created for it in the ServiceModule. If there is a session, then we
  // should not create a task for it (that's handled in handleSessionOffered)
  // if there are queues attached to the call then it is an external call
  if (
    event.queueIds.length >= 1 ||
    ServiceModule.hasSession(event.pcsConversationSid)
  ) {
    context.logger.debug(
      `Incoming call (${direction} - ${from}) is external call`,
      event,
    );
    return;
  }

  // if there is no session, then it's an internal or outbound call and
  // we should create a task for it

  if (event.originating) {
    // outbound call
    context.logger.debug(`Outgoing call to (${from})`, event);
    setOutboundCallToOffered(context, event.callId, from);
  } else if (event.terminating) {
    // internal call create a internal task
    setInternalCallToOffered(context, event.callId, from, event.remoteIdentity);
  }

  context.parent.setSelectedTaskId(event.callId);
}

export default handleCallPlaced;
